import { generatePath, RouteObject } from 'react-router-dom';
import { DistrictRoutes } from './constants';
import { FamiliesListDistrictLevelPage } from '../family/pages/family-list/family-list-district-level.page';
import { FamilyDetailsPage } from '../family/pages/family-details/family-details.page';
import { CustomRequirementsListPage } from '../custom-requirements/pages/custom-requirements-list.page';
import { UsersListPage } from '../user-managment/pages/users-list/users-list.page';
import { ProvidersDetailsPage } from '../providers/pages/providers-details/providers-details.page';
import { EngagementsListDistrictLevelPage } from '../engagement/pages/engagements-list/engagements-list-district-level.page';
import { EngagementDetailsPage } from '../engagement/pages/engagements-details/engagements-details.page';
import { SurveyPreviewPage } from '../survey/pages/survey-view/survey-preview.page';
import { SurveyTemplateActionPage } from '../survey/pages/survey-template-actions/survey-template-action.page';
import { SurveyTemplateListDistrictLevelPage } from '../survey/pages/survey-template-list/survey-list-district-level.page';
import { DashboardDistrictLevelPage } from '../dashboard/pages/dasboard-district-level.page';
import { ProvidersListDistrictLevelPage } from '../providers/pages/providers-list/provider-list-district-level.page';
import { SurveyStatisticsDistrictLevelPage } from '../survey/pages/survey-statistic/survey-statistics/survey-statistic-district.page';
import { QuestionAnswersDistrictLevelPage } from '../survey/pages/survey-statistic/question-answers/question-answers-district.page';
import { FamilyAnswersDistrictLevelPage } from '../survey/pages/survey-statistic/family-answers/family-answers-district.page';
import { AnalyticsDistrictLevelPage } from '../analytics/pages/analytics-district-level.page';

export const DistrictAdminModuleRouter: RouteObject[] = [
	{
		path: DistrictRoutes.CustomRequirements,
		element: <CustomRequirementsListPage />,
		handle: { title: 'headers.custom-requirements' },
	},
	{ path: DistrictRoutes.UserManagment, element: <UsersListPage />, handle: { title: 'headers.users' } },
];

export const DistrictModuleRouter: RouteObject[] = [
	{
		path: DistrictRoutes.Dashboard,
		element: <DashboardDistrictLevelPage />,
		handle: { title: 'nav.dashboard', needsPaper: false },
	},
	{
		path: DistrictRoutes.Analytics,
		element: <AnalyticsDistrictLevelPage />,
		handle: { title: 'nav.analytics', needsPaper: false },
	},
	{
		path: DistrictRoutes.Families.Root,
		element: <FamiliesListDistrictLevelPage />,
		handle: { title: 'headers.families' },
	},
	{
		path: DistrictRoutes.Families.Details,
		element: <FamilyDetailsPage />,
		handle: {
			title: 'headers.family-details',
			needsPaper: false,
			to: { path: DistrictRoutes.Families.Root },
		},
	},
	{
		path: DistrictRoutes.Engagements.Root,
		element: <EngagementsListDistrictLevelPage />,
		handle: { title: 'headers.engagements', needsPaper: false },
	},

	{
		path: DistrictRoutes.Providers.Root,
		element: <ProvidersListDistrictLevelPage />,
		handle: { title: 'headers.providers' },
	},
	{
		path: DistrictRoutes.Providers.Details,
		element: <ProvidersDetailsPage />,
		handle: {
			title: 'headers.providers-details',
			needsPaper: false,
			to: { path: DistrictRoutes.Providers.Root },
		},
	},

	{
		path: DistrictRoutes.Engagements.Details,
		element: <EngagementDetailsPage />,
		handle: {
			title: 'headers.engagement-details',
			needsPaper: false,
			to: { path: DistrictRoutes.Engagements.Root },
		},
	},
	{
		path: DistrictRoutes.Engagements.DetailsLL,
		element: <EngagementDetailsPage />,
		handle: {
			title: 'headers.engagement-details-ll',
			needsPaper: false,
			to: { path: DistrictRoutes.Engagements.Root },
		},
	},
	{
		path: DistrictRoutes.SurveyTemplates.Root,
		element: <SurveyTemplateListDistrictLevelPage />,
		handle: { title: 'headers.survey-templates' },
	},
	{
		path: DistrictRoutes.SurveyTemplates.Creating,
		element: <SurveyTemplateActionPage />,
		handle: {
			title: 'headers.survey-creating',
			needsPaper: false,
			to: { path: DistrictRoutes.SurveyTemplates.Root },
		},
	},
	{
		path: DistrictRoutes.SurveyTemplates.Editing,
		element: <SurveyTemplateActionPage />,
		handle: {
			title: 'headers.survey-editing',
			needsPaper: false,
			to: { path: DistrictRoutes.SurveyTemplates.Root },
		},
	},
	{
		path: DistrictRoutes.SurveyTemplates.Details,
		element: <SurveyPreviewPage />,
		handle: {
			title: 'headers.survey',
			needsDrawer: false,
			to: { path: DistrictRoutes.SurveyTemplates.Root },
		},
	},
	{
		path: DistrictRoutes.SurveyTemplates.Overview,
		element: <SurveyStatisticsDistrictLevelPage />,
		handle: {
			title: 'headers.survey-template-name',
			to: { path: DistrictRoutes.SurveyTemplates.Root },
		},
	},
	{
		path: DistrictRoutes.SurveyTemplates.QuestionStats,
		element: <QuestionAnswersDistrictLevelPage />,
		handle: {
			title: 'headers.survey-template-name',
			to: (params: { surveyTemplateId: any }) => ({
				path: generatePath(DistrictRoutes.SurveyTemplates.Overview, {
					surveyTemplateId: params.surveyTemplateId,
				}),
			}),
		},
	},
	{
		path: DistrictRoutes.SurveyTemplates.FamilyStats,
		element: <FamilyAnswersDistrictLevelPage />,
		handle: {
			title: 'headers.survey-template-name',
			to: (params: { surveyTemplateId: any }) => ({
				path: generatePath(DistrictRoutes.SurveyTemplates.Overview, {
					surveyTemplateId: params.surveyTemplateId,
				}),
			}),
		},
	},
];
